export default "__VITE_ASSET__gv4F40ol__"